import MetaTags from "react-meta-tags"
import React from "react"
import { Container } from "reactstrap"
import FollowUp from "../../components/Admin/Followup-Status"

const FollowupStatus = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Follow Statuses | KlikCRM</title>
        </MetaTags>
        <Container fluid>
          <FollowUp />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default FollowupStatus
